export const FormLabelStyle = {
    color: "gray.600",
    fontWeight: 400,
    fontSize: "sm",
};
